// マスタ系 Accordion のサマリ行(見出し部分)の共通骨格。
// AccordionSummary 直下の Stack + 先頭 ID Chip + 名称 + 状態Chip群 + 右寄せの編集/複製/削除ボタン、
// という各マスタページで重複していた DOM 構造をまとめたもの。

import { ReactNode } from "react";
import { AccordionSummary, Box, Chip, Stack } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

export function MasterAccordionSummary({ idLabel, title, chips, actions, wrap }: {
  idLabel: string;
  title: ReactNode;
  // タイトルの後ろ、アクション群の前に並べる要素。右寄せしたい要素の手前に <Box flex={1} /> を
  // 挟むかどうかは呼び出し側のレイアウトに委ねる。
  chips?: ReactNode;
  actions?: ReactNode;
  wrap?: boolean;
}) {
  return (
    // サマリ行に IconButton(button) を含むため、button-in-button のHTML不正を避けて div で描画する
    <AccordionSummary component="div" expandIcon={<ExpandMoreIcon />}>
      <Stack direction="row" alignItems="center" gap={1.5} flex={1} mr={2} flexWrap={wrap ? "wrap" : undefined}>
        <Chip size="small" variant="outlined" label={idLabel} />
        {title}
        {chips}
        <Box display="flex" gap={0.5} onClick={(e) => e.stopPropagation()}>
          {actions}
        </Box>
      </Stack>
    </AccordionSummary>
  );
}
